export enum BTableColumnType{
    Date = 0,
    Time = 1,
    DateTime = 2,
    TimeDate = 3,
    Bool = 4,
    Custom = 5
}